'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBonusState = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Translate = require('../../components/Translate');

var _Translate2 = _interopRequireDefault(_Translate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getBonusState = exports.getBonusState = function getBonusState(state) {
  var translations = {
    Active: _react2.default.createElement(_Translate2.default, { id: 'label.state.bonus.Active', defaultMessage: 'Active' }),
    Expired: _react2.default.createElement(_Translate2.default, { id: 'label.state.bonus.Expired', defaultMessage: 'Expired' }),
    Finished: _react2.default.createElement(_Translate2.default, { id: 'label.state.bonus.Finished', defaultMessage: 'Finished' }),
    Canceled: _react2.default.createElement(_Translate2.default, { id: 'label.state.bonus.Canceled', defaultMessage: 'Canceled' }),
    FinishedNoGains: _react2.default.createElement(_Translate2.default, {
      id: 'label.state.bonus.FinishedNoGains',
      defaultMessage: 'Finished No Gains'
    }),
    Rejected: _react2.default.createElement(_Translate2.default, { id: 'label.state.bonus.Rejected', defaultMessage: 'Rejected' }),
    Initiated: _react2.default.createElement(_Translate2.default, { id: 'label.state.bonus.Initiated', defaultMessage: 'Initiated' }),
    PreClaimed: _react2.default.createElement(_Translate2.default, {
      id: 'label.state.bonus.PreClaimed',
      defaultMessage: 'Pre Claimed'
    }),
    InPlay: _react2.default.createElement(_Translate2.default, { id: 'label.state.bonus.InPlay', defaultMessage: 'In Play' }),
    Pending: _react2.default.createElement(_Translate2.default, { id: 'label.state.bonus.Pending', defaultMessage: 'Pending' }),
    PreWager: _react2.default.createElement(_Translate2.default, { id: 'label.state.bonus.PreWager', defaultMessage: 'Pre Wager' }),
    AdminCanceled: _react2.default.createElement(_Translate2.default, {
      id: 'label.state.bonus.AdminCanceled',
      defaultMessage: 'Admin Canceled'
    })
  };

  return translations[state] || _react2.default.createElement(
    'span',
    null,
    state
  );
};